import React from 'react';
import PropTypes from 'prop-types';

import FormDivider from '@atoms/form/FormDivider/FormDivider';
import ConfirmationWrapper from '@molecules/security/ConfirmationWrapper';

import { FormSuccess, FormError } from 'IMAGE';
import { tConsume } from 'TRANSLATION';
import api from 'API';

const TfaConfirm = ({ userType, data, toggleModal, t, tfaMethod, getData }) => {
  let CONFIG;

  if (userType === 'aemi') {
    CONFIG = api.banking.client.aemiExchanges(data.temporary_order_id);
  } else {
    CONFIG = api.banking.client.exchanges();
  }

  return (
    <ConfirmationWrapper
      tfaMethod={tfaMethod}
      userType={userType}
      toggleModal={toggleModal}
      updateTransation={getData}
      data={data}
      phone={true}
      link={CONFIG}
      iconSuccess={FormSuccess}
      textSuccess={<h2 className={'align-center'}>{t('page.successfully')}</h2>}
      iconError={FormError}
      textError={
        <>
          <h2 className={'align-center'}>{t('page.error')}</h2>
          <p>{t('page.errorText')}</p>
        </>
      }
    >
      <FormDivider />
    </ConfirmationWrapper>
  );
};

export default tConsume(TfaConfirm);

TfaConfirm.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  userType: PropTypes.string.isRequired,
  tfaMethod: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  change: PropTypes.bool,
  t: PropTypes.func.isRequired,
  getData: PropTypes.func,
};
